import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import HighchartsReact from 'highcharts-react-official';

export const Wrapper = styled(Box)``;
export const Chart = styled(HighchartsReact)`
  .highcharts-data-label {
    display: none;
  }

  .xxxxxxxxx {
    display: none !important;
  }
  &.xxxxxxxxx {
    display: none !important;
  }
  & > .xxxxxxxxx {
    display: none !important;
  }
`;
